export default __webpack_public_path__ + "static/media/no olvidamos.2bdc423e.jpg";